import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { NeptuneApi } from '../genericApi/neptune.api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';

import { DisplayGroupApiModel } from './models/display-group.api.model';
import { DisplayGroupTypeEnum } from './enums/display-group-type.enum';

@Injectable()
export class DisplayGroupsApi {

    constructor(
        private neptuneApi: NeptuneApi
    ) {}

    public getLhpGroupsByType(type: DisplayGroupTypeEnum): Observable<DisplayGroupApiModel[]> {
        return this.neptuneApi.api<DisplayGroupApiModel[]>(
            `/displaygroups?type=${type}`,
            undefined,
            HttpVerbsEnum.GET
        );
    }

    public createGroup(group: DisplayGroupApiModel): Observable<number> {
        return this.neptuneApi.api<number>(
            '/displaygroups',
            group,
            HttpVerbsEnum.POST
        );
    }

    public updateGroup(group: DisplayGroupApiModel): Observable<void> {
        return this.neptuneApi.api<void>(
            `/displaygroups/${group.id}`,
            group,
            HttpVerbsEnum.PUT
        );
    }

    public deleteGroup(id: number): Observable<void> {
        return this.neptuneApi.api<void>(
            `/displaygroups/${id}`,
            undefined,
            HttpVerbsEnum.DELETE
        );
    }

}
